import React, { useEffect, useRef } from "react";
import { Section } from "./primitives";

export const Waitlist = () => {
  const ref = useRef(null);

  useEffect(() => {
    const container = ref.current;
    if (!container) return;
    const s = document.createElement("script");
    s.async = true;
    s.setAttribute("data-uid", "c6aa9deb74");
    s.src = "https://fulltimeguitar2023.kit.com/c6aa9deb74/index.js";
    container.appendChild(s);
    return () => {
      container.innerHTML = "";
    };
  }, []);

  return (
    <Section id="waitlist" className="bg-white">
      <div className="max-w-[1100px] mx-auto" ref={ref} data-testid="waitlist-embed" />
    </Section>
  );
};
